import { r as e } from "../../chunks/index.es.wVhS2yfK.js";
import { Element as t, Node as n, Transforms as r } from "slate";
// lib/TTVisual/lib/normalizeTTVisual.ts
var i = /* @__PURE__ */ new Set([
	"tt/visual/image",
	"tt/visual/text",
	"tt/visual/byline"
]), a = (a, o) => {
	let [, s] = o;
	for (let [o, c] of n.children(a, s)) if (t.isElement(o) && e.isBlock(o) && !i.has(o.type)) return r.unwrapNodes(a, {
		at: c,
		split: !0
	}), !0;
};
export { a as normalizeTTVisual };
